import { Suspense, SuspenseProps } from 'react';

export const Loadable =
  (Component: any, fallback: SuspenseProps['fallback']) => (props: any) =>
    (
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    );
